import { ClubBean, CompanyDTO } from "@gymflow/types";
import { AxiosInstance } from "axios";

export type CompanyApiType = ReturnType<typeof companyApi>;
const companyApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  return {
    details() {
      return axiosInstance.get<ClubBean>(`${clubPrefix}company`);
    },
    updateDetails(_clubId: number, payload: Partial<CompanyDTO>) {
      return axiosInstance.patch<CompanyDTO>(`${clubPrefix}company`, payload);
    },
  };
};

export default companyApi;
